<template>
  <div class="home">
    <div
      style="font-family: 'Poppins', sans-serif; padding: .5rem 0px; border-top: 1px solid #C8C3C2; border-bottom: 1px solid #C8C3C2; text-align: center; font-weight: 200;"
      v-if="!showSearch"
    >
      Llené de libros mi habitación, perdiéndome en historias que me hicieron
      olvidar la mía.
    </div>
    <features />
    <main-title title="Novedades" />
    <book-list :items="starrybooks" />
    <main-title title="Recibí nuestras noticias" />
    <suscribe-bar />
    <main-title title="Qué más voy a leer" />
    <book-page :items="nextbooks" nopagination view="grid"/>
    <div class="d-flex flex-wrap mt-3">
      <div
        class="flex-fill m-2 big-box d-flex align-items-center justify-content-center"
        :style="advertise[0].background"
        @click="openWindow(advertise[0].link);"
      ></div>
      <div
        class="flex-fill m-2 big-box d-flex align-items-center justify-content-center"
        :style="advertise[1].background"
        @click="openWindow(advertise[1].link);"
      ></div>
      <div
        class="flex-fill m-2 big-box d-flex align-items-center justify-content-center"
        :style="advertise[2].background"
        @click="openWindow(advertise[2].link);"
      ></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Features from "@/components/Features.vue";
import MainTitle from "@/components/MainTitle.vue";
import BookList from "@/components/BookList.vue";
import BookPage from "@/components/BookPage.vue";
import SuscribeBar from "@/components/SuscribeBar.vue";
import axios from "axios";

export default {
  name: "Home",
  components: {
    Features,
    MainTitle,
    BookList,
    BookPage,
    SuscribeBar
  },
  data() {
    return {
      starrybooks: [],
      nextbooks: [],
      advertise: []
    };
  },
  mounted() {
    this.updateStarryBooks();
    this.updateNextBooks();
    this.updateAdvertise();
    const w = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
        
    if (w < 768){
      this.$parent.showSearch = true;
      this.$parent.$refs.navbar.showSearch = true;
    }
  },
  computed: {
    demo: function() {
      const result = [];
      for (let page = 0; page < 2; page++) {
        for (let bookData = 1; bookData < 5; bookData++) {
          result.push({
            imgCover: "img/7.png",
            bookTitle: "Comunicación y periodismo",
            bookDesc: "Sivana Comba y Edgardo Toledo",
            bookId: bookData + page * 4,
            size: 25
          });
        }
      }
      return result;
    },
    newsTitle: function() {
      const monthNames = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ];
      const now = new Date();
      return "Novedades de " + monthNames[now.getMonth()];
    },
    showSearch: function() {
      return this.$parent.showSearch;
    }
  },
  methods: {
    async updateStarryBooks() {
      console.log(this.$store.state.user.siteData);

      this.starrybooks = await axios
        .post(
          this.$store.state.user.siteData.location + "items/books/getForStore",
          JSON.stringify({ type: "news" }),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            result.push({
              imgCover:
                this.$store.state.user.siteData.location +
                "repository/books/" +
                element.id +
                "_" +
                element.img,
              bookTitle: element.title,
              bookDesc: element.author,
              bookId: parseInt(element.id),
              bookResume: element.resume,
              bookSubtitle: element.subtitle,
              bookPrice: element.price,
              bookStock: parseInt(element.stock),
              regularCost: element.regularcost,
              size: 25,
              promo: element.promo
            });
          });
          return result;
        });
    },
    async updateNextBooks() {
      console.log(this.$store.state.user.siteData);

      this.nextbooks = await axios
        .post(
          this.$store.state.user.siteData.location + "items/books/getForStore",
          JSON.stringify({ type: "next" }),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            result.push({
              imgCover:
                this.$store.state.user.siteData.location +
                "repository/books/" +
                element.id +
                "_" +
                element.img,
              bookTitle: element.title,
              bookDesc: element.author,
              bookId: parseInt(element.id),
              bookStock: parseInt(element.stock),
              bookResume: element.resume,
              bookSubtitle: element.subtitle,
              bookPrice: element.price,
              regularCost: element.regularcost,
              size: 25,
              promo: element.promo
            });
          });
          return result;
        });
    },
    async updateAdvertise(){
      this.advertise = await axios
        .post(
          this.$store.state.user.siteData.location + "banners/advertising/getForStore",
          null,
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          evtResponse.data.records.forEach(element => {
            element.background =
              "background-image: url('" +
              this.$store.state.user.siteData.location +
              "repository/advertising/" +
              element.id +
              "')";
          })
          return evtResponse.data.records;
        });
    },
    openWindow(dest){
      if (dest !== '' && dest !== null) {
        window.open(dest);
      }
    }
  }
};
</script>
